import { render } from "./Q5Simple.vue?vue&type=template&id=4fd31b31"
import script from "./Q5Simple.vue?vue&type=script&lang=js"
export * from "./Q5Simple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__